module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isSimulation) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "prefix-3 gr-3"
  }, [_c('progress-assessment')], 1), (_vm.getResultSimulationInfo) ? _c('div', {
    staticClass: "gr-3"
  }, [_c('vue-position-sticky', [_c('div', {
    staticClass: "shadow-box pa-15"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getResultSimulationInfo.penaltyExcludingReduction),
      expression: "getResultSimulationInfo.penaltyExcludingReduction"
    }]
  }, [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("Penalty (ex. reduction):")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.penaltyExcludingReduction))]), _c('div', [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("Penalty:")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.penalty))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getResultSimulationInfo.reductionApplicable),
      expression: "getResultSimulationInfo.reductionApplicable"
    }]
  }, [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("Reduction applicable:")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.reductionApplicable))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getResultSimulationInfo.reductionFactor),
      expression: "getResultSimulationInfo.reductionFactor"
    }]
  }, [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("Reduction factor:")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.reductionFactor))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getResultSimulationInfo.siteSecurityClassification),
      expression: "getResultSimulationInfo.siteSecurityClassification"
    }]
  }, [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("SSC:")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.siteSecurityClassification))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getResultSimulationInfo.overwriteSiteSecurityClassificationInfo),
      expression: "getResultSimulationInfo.overwriteSiteSecurityClassificationInfo"
    }]
  }, [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("Overwrite SSC:")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.overwriteSiteSecurityClassificationInfo))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getResultSimulationInfo.riskLevel),
      expression: "getResultSimulationInfo.riskLevel"
    }]
  }, [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("RiskLevel:")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.riskLevel))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getResultSimulationInfo.risklevelBasedOnQuestions),
      expression: "getResultSimulationInfo.risklevelBasedOnQuestions"
    }]
  }, [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("Risklevel (questions):")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.risklevelBasedOnQuestions))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getResultSimulationInfo.risklevelBasedOnCountry),
      expression: "getResultSimulationInfo.risklevelBasedOnCountry"
    }]
  }, [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("Risklevel (country):")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.risklevelBasedOnCountry))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getResultSimulationInfo.countryRisk),
      expression: "getResultSimulationInfo.countryRisk"
    }]
  }, [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("Country risk:")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.countryRisk))]), _c('div', [_c('span', {
    staticClass: "txt-bold"
  }, [_vm._v("Compliance score:")]), _vm._v(" " + _vm._s(_vm.getResultSimulationInfo.complianceScore))])])])], 1) : _vm._e()]) : _c('progress-assessment'), _c('div', {
    staticClass: "gr-10@md gr-8@lg gr-12@sm gr-12@xs prefix-1@md prefix-2@lg prefix-2@xl mt-30"
  }, [_c('div', {
    staticClass: "category-list"
  }, _vm._l((_vm.categories), function(category, key) {
    return _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading || _vm.questionLoading),
        expression: "loading || questionLoading"
      }],
      staticClass: "category-list__category shadow-box",
      class: {
        'category-list__category--active': (key === _vm.activeCategory)
      },
      attrs: {
        "element-loading-text": "Saving..."
      }
    }, [_c('div', {
      staticClass: "pa-30 mb-15 mt-15"
    }, [_c('h1', {
      staticClass: "category__title txt-center"
    }, [_vm._v(_vm._s(category.name))]), (category.intro.length > 0) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "category__intro gr-12@xs prefix-0@xs gr-10@md prefix-1@md",
      domProps: {
        "innerHTML": _vm._s(category.intro)
      }
    })]) : _vm._e(), (_vm.isSimulation && category.questions.length > 0) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "gr-10"
    }, [_vm._v("\n                             \n                        ")]), _vm._m(0, true)]) : _vm._e(), _vm._l((_vm.getQuestionsOfCategory(key)), function(item) {
      return _c('question', {
        key: item.id,
        attrs: {
          "assessment-id": _vm.getAssessmentId,
          "is-simulation": _vm.isSimulation,
          "category-id": key,
          "question-id": item.id,
          "question-comment-title": _vm.questionCommentTitle,
          "question-comment-tooltip": _vm.questionCommentTooltip
        }
      })
    })], 2)])
  }), 0)]), _c('div', {
    staticClass: "btn-group btn-group--fixed txt-center"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.firstCategory),
      expression: "firstCategory"
    }]
  }, [_c('div', {
    staticClass: "hide@xs hide@sm show@md show@lg show@xl"
  }, [_c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary btn--big",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('exit')
      }
    }
  }, [_vm._v("Save & Exit")]), _c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary btn--big",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.printAssessment()
      }
    }
  }, [_vm._v("Print")]), _c('el-button', {
    staticClass: "btn btn--shadow btn--secondary btn--big",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('next')
      }
    }
  }, [_vm._v("Start")])], 1), _c('div', {
    staticClass: "show@xs show@sm hide@md hide@lg hide@xl"
  }, [_c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('exit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.printAssessment()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  })]), _c('el-button', {
    staticClass: "btn btn--shadow btn--secondary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('next')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notFirstOrLastCategory),
      expression: "notFirstOrLastCategory"
    }]
  }, [_c('div', {
    staticClass: "hide@xs hide@sm show@md show@lg show@xl"
  }, [_c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary btn--big",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('previous')
      }
    }
  }, [_vm._v("Previous")]), _c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary btn--big",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.printAssessment()
      }
    }
  }, [_vm._v("Print")]), _c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary btn--big",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('exit')
      }
    }
  }, [_vm._v("Save & Exit")]), _c('el-button', {
    staticClass: "btn btn--shadow btn--secondary btn--big",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('next')
      }
    }
  }, [_vm._v("Next")])], 1), _c('div', {
    staticClass: "show@xs show@sm hide@md hide@lg hide@xl"
  }, [_c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('previous')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.printAssessment()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  })]), _c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('exit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _c('el-button', {
    staticClass: "btn btn--shadow btn--secondary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('next')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lastCategory),
      expression: "lastCategory"
    }]
  }, [_c('div', {
    staticClass: "hide@xs hide@sm show@md show@lg show@xl"
  }, [_c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary btn--big",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('previous')
      }
    }
  }, [_vm._v("Change answers")]), _c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary btn--big",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.printAssessment()
      }
    }
  }, [_vm._v("Print")]), _c('el-button', {
    staticClass: "btn btn--shadow btn--secondary btn--big",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('confirm')
      }
    }
  }, [_vm._v("Calculate risk")])], 1), _c('div', {
    staticClass: "show@xs show@sm hide@md hide@lg hide@xl"
  }, [_c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('previous')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.printAssessment()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  })]), _c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAssessment('confirm')
      }
    }
  }, [_vm._v("Calculate risk")])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gr-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "gr-6 txt-center u-weight-bold"
  }, [_vm._v("\n                                    P\n                                ")]), _c('div', {
    staticClass: "gr-6 txt-center u-weight-bold"
  }, [_vm._v("\n                                    R\n                                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12dc7946","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/assessment.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-12dc7946","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/assessment.vue
// module chunks = 0